// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStandingsGetBody = {
  leagueId: string | null;
  grouping: string | null;
};

export type typeStandingsGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    leagueId: string;
    leagueName: string;
    seasonLabel: string;
    grouping: string;
    groupings: { key: string; label: string }[];
    primaryColumns: { key: string; label: string }[];
    secondaryColumns: { key: string; label: string }[];
    groups: {
      key: string;
      label: string;
      parentLabel?: string | null;
      rows: {
        teamId: string;
        rank: number;
        rankLabel: string;
        teamName: string;
        teamAbbr: string;
        cells: { key: string; value?: number | null; display: string }[];
        logoUrl?: string | null;
      }[];
    }[];
    emptyReason?: string | null;
  };
};

export type typeStandingsGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStandingsGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStandingsGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStandingsGetBody = {
  type: "object",
  properties: {
    leagueId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    grouping: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["leagueId", "grouping"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStandingsGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStandingsGetBody);
  }

  return async function postStandingsGet(
    payload: typeStandingsGetBody,
  ): Promise<typeStandingsGetOutput200 | typeStandingsGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStandingsGet" failed before calling the network. #a14c88c767af`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#a14c88c767af" },
        },
        data: null,
      } as typeStandingsGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/standings/get`,
      httpMethod: "POST",
      options,
    })) as typeStandingsGetOutput200 | typeStandingsGetOutput400;
  };
}
